import { useWallet } from '@aptos-labs/wallet-adapter-react'
import DataPoint from 'components/common/DataPoint'
import { useAppSelector } from 'state/hooks'
import {
  selectBorrowTransactions,
  selectBrokerHistoriesLoaded,
  selectLendTransactions
} from 'state/slices/app/brokerHistories'
import {
  selectBalanceHistoryLoaded,
  selectBorrowingPoints,
  selectLendingPoints,
  selectTotalPoints
} from 'state/slices/user/balanceHistory'
import { formatPublicKeyDisplay } from 'toolbox/format'
import pixelated from 'assets/icons/pixelated.svg'

export function Points() {
  const loaded = useAppSelector(selectBrokerHistoriesLoaded)
  const testnetLendTx = useAppSelector(selectLendTransactions)
  const testnetBorrowTx = useAppSelector(selectBorrowTransactions)
  const { account } = useWallet()

  const totalPoints = useAppSelector(selectTotalPoints)
  const lendingPoints = useAppSelector(selectLendingPoints)
  const borrowingPoints = useAppSelector(selectBorrowingPoints)
  const balanceHistoryLoaded = useAppSelector(selectBalanceHistoryLoaded)
  const lendTxLength = testnetLendTx.length >= 10 ? 10 : testnetLendTx.length
  const borrowTxLength = testnetBorrowTx.length >= 10 ? 10 : testnetBorrowTx.length

  const isTestnet = process.env.REACT_APP_APTOS_NETWORK_SHORT === 'testnet'
  const isLoaded = isTestnet ? loaded : balanceHistoryLoaded

  // const nextTier = 500
  // const getPoints = 100

  // const largeRecRight = {
  //   label: `Next tier: ${nextTier} points`,
  //   value: `Get +${getPoints}`,
  //   right: true
  // }

  const totalPointsDisplay = isTestnet ? (lendTxLength + borrowTxLength) * 200 : totalPoints
  const lendingPointsDisplay = isTestnet ? lendTxLength * 200 : lendingPoints
  const borrowingPointsDisplay = isTestnet ? borrowTxLength * 200 : borrowingPoints

  const largeRecLeft = {
    label: 'Total points earned',
    value: isLoaded ? totalPointsDisplay : '--'
  }

  const smallRecs = [
    {
      label: 'Lending points',
      value: isLoaded ? lendingPointsDisplay : '--'
    },
    {
      label: 'Borrowing points',
      value: isLoaded ? borrowingPointsDisplay : '--'
    }
    // {
    //   label: 'Referral points',
    //   value: isLoaded ? referralPoints : '--'
    // }
  ]

  const smallRecDisplay = smallRecs.map((dp, i) => (
    <div className="rec small" key={i}>
      <DataPoint key={i} {...dp} />
    </div>
  ))

  const captions = isTestnet
    ? [
        // '* Updated at 0:00 UTC every day',
        '* Points are earned based on protocol activity:',
        '200 Points per lend transaction, max 10 transactions per wallet',
        '200 Points per borrow transaction, max 10 transactions per wallet'
      ]
    : [
        // '* Updated at 0:00 UTC every day',
        '* Points are earned based on protocol activity:',
        '1 Point per dollar lent per day',
        '1 Point per dollar borrowed per day'
      ]

  const captionsDisplay = captions.map((c, i) => (
    <p key={i} className="points-caption">
      {c}
    </p>
  ))

  return (
    <div className="points">
      <h1>Points</h1>
      <div className="points-card">
        <div className="user-address">
          <img src={pixelated} alt="profile" className="prof-pic" />
          <p className="address">{formatPublicKeyDisplay(account?.address)}</p>
        </div>
        <div className="user-points">
          <div className="rec large">
            <div className="rec-dp-content">
              <DataPoint {...largeRecLeft} />
              <div className="rec-dp-right">{/* <DataPoint {...largeRecRight} /> */}</div>
            </div>
            {/* <progress className="p-bar" value={totalPoints} max={nextTier} /> */}
            {/* <p className="disclaimer">* Updated at 0:00 UTC every day</p> */}
          </div>
          {smallRecDisplay}
        </div>
        <hr className="hr" />
        <div className="points-captions">{captionsDisplay}</div>
      </div>
    </div>
  )
}
